import { SampleBoardMaterialRecipeItem } from "@app/strain/sample-boards/models/sample-board-material-recipe-item.model";

export class SampleBoardRecipe {
    id: number;
    recipeMaterials: SampleBoardMaterialRecipeItem[];

    constructor(entry: any = {}) {
        this.id = entry.id || entry?.recipeId || 0;
        const rawItems = entry?.recipeMaterials
            || entry?.materials
            || entry?.items
            || [];
        this.recipeMaterials = rawItems.map((item: any) => new SampleBoardMaterialRecipeItem(item));
    }
}
